export default __webpack_public_path__ + "77361068fd85ca205be2977a0efa1341.svg";